import {
  ADD_FORM_INSTANCE,
  ADD_TEMPLATE_TO_PROJECT,
  CLEAR_TEMPLATES,
  DELETE_FORM_INSTANCE,
  DOWNLOAD_IMPORT_TEMPLATE,
  GET_AVAILABLE_FORMS,
  GET_INFORMATIONS_ABOUT_AVAILABLE_FORMS,
  GET_PHASES,
  GET_PRIORITIES,
  GET_STATUS,
  IMPORT_FORMS,
  REMOVE_TEMPLATE_TO_PROJECT,
  SET_BULK_PHASE,
  SET_FORM_STATUS,
  SET_LAST_CONFIGS,
  SET_LOADING_FLAG,
  SET_PHASES,
  SET_PRIORITIES,
  SET_STATUS,
  SET_STATUS_LIST,
} from 'containers/OneProjectPage/FormsPage/constants';

export function setLoadingFlag(loading) {
  return {
    type: SET_LOADING_FLAG,
    loading,
  };
}

export function setStatusList(statusList) {
  return {
    type: SET_STATUS_LIST,
    statusList,
  };
}

export function setFormStatus(idData, optionId, statusId) {
  return { type: SET_FORM_STATUS, idData, optionId, statusId };
}

export function getStatus({ params }) {
  return {
    type: GET_STATUS,
    params,
  };
}

export function setStatus(status) {
  return {
    type: SET_STATUS,
    status,
  };
}

export function getPriorities() {
  return {
    type: GET_PRIORITIES,
  };
}

export function setPriorities(priorities) {
  return {
    type: SET_PRIORITIES,
    priorities,
  };
}

export function getPhases({ params }) {
  return {
    type: GET_PHASES,
    params,
  };
}

export function setPhases(phases) {
  return {
    type: SET_PHASES,
    phases,
  };
}

export function addTemplateToProject(template) {
  return {
    type: ADD_TEMPLATE_TO_PROJECT,
    template,
  };
}
export function removeTemplateToProject(template) {
  return {
    type: REMOVE_TEMPLATE_TO_PROJECT,
    template,
  };
}
export function clearTemplates() {
  return {
    type: CLEAR_TEMPLATES,
  };
}

export function getAvailableForms({ moduleId, callback }) {
  return {
    type: GET_AVAILABLE_FORMS,
    moduleId,
    callback,
  };
}

export function getInformationsAboutAvailableForms({
  formsIds,
  callback,
  searchTerm,
  width_disabled = false,
}) {
  return {
    type: GET_INFORMATIONS_ABOUT_AVAILABLE_FORMS,
    formsIds,
    callback,
    searchTerm,
    width_disabled,
  };
}

export function addFormInstance(
  formTemplate,
  position,
  moduleId,
  source,
  isOccupiedSiteRenovation,
  callback,
) {
  return {
    type: ADD_FORM_INSTANCE,
    formTemplate,
    position,
    moduleId,
    source,
    isOccupiedSiteRenovation,
    callback,
  };
}

export function deleteFormInstance(formInstanceId, listRequestOption) {
  return {
    type: DELETE_FORM_INSTANCE,
    formInstanceId,
    listRequestOption,
  };
}

export function changeBulkPhase(formInstanceIds, phaseId, listsRequestOption) {
  return {
    type: SET_BULK_PHASE,
    formInstanceIds,
    phaseId,
    listsRequestOption,
  };
}

export function excelImportForms(item, params, listRequestOption, callback) {
  return {
    type: IMPORT_FORMS,
    item,
    params,
    listRequestOption,
    callback,
  };
}

export function downloadImportTemplate(params) {
  return {
    type: DOWNLOAD_IMPORT_TEMPLATE,
    params,
  };
}

export function setLastConfigs(configs) {
  return {
    type: SET_LAST_CONFIGS,
    configs,
  };
}
